import { NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction | null = null;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const navigateTo = (path: string, replace: boolean = false) => {
  console.log(path);
  if (navigate) {
    navigate(path, { replace });
  } else {
    console.warn("Navigate function is not set.");
  }
};
